
export enum NotificationSizeEnums {
  LARGE = 'large',
  COLOR = 'white'

}


export enum NotificationStyleEnums {
  COLOR = 'white',
  BACKGROUND_COLOR = '#005CA3',
  BACKGROUND_COLOR_TRANSPARENT = 'transparent',
  BORDER = '1px solid #E1E3ED',
  
}
